import React, { useMemo } from "react";
import { useParams } from "react-router-dom";
import { Box } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import { APIError } from "../../components/APIError";

import { MeterReadingsList } from "./components/MeterReadingList";
import { ExtendedContainer } from "../../components/ExtendedContainer";
import { AlertBlock } from "../../components/AlertBlock";
import { useMeterPointReadings } from "../../api/hooks";
import { Meter } from "../../api/meters";
import { FormSectionHeading } from "../../components/Forms";

export const MeterReadingsContainer: React.FC<{
  meter: Meter;
}> = ({ meter }) => {
  const { meterPointId } = useParams();
  const { data, status, error } = useMeterPointReadings(meterPointId!);
  const { id: meterId } = meter!;

  const readings = useMemo(
    () => data?.find((d) => d.meterId === meterId)?.readings || [],
    [data, meterId],
  );

  return (
    <ExtendedContainer p={0} maxWidth="none" mt={2}>
      <FormSectionHeading data-testid="MeterReadingsContainer__Heading">
        PREVIOUS READINGS
      </FormSectionHeading>
      <Box mt={3}>
        {meterId === undefined ? null : status === "loading" ? (
          <Box data-testid="Loader">
            <Skeleton variant="text" width="60%" height={27} animation="wave" />
            <Skeleton variant="text" width="30%" height={20} animation="wave" />
          </Box>
        ) : status === "error" ? (
          <APIError
            title="We could not load meter readings for this meter."
            messages={[(error as Error).message]}
            data-testid="MeterReadingsContainer__Error"
          />
        ) : readings.length === 0 ? (
          <AlertBlock
            data-testid="MeterReadingsContainer__Empty"
            variant="info"
            messages={["No readings are found for this meter."]}
            isClosable={false}
          />
        ) : (
          <MeterReadingsList readings={readings!} meter={meter} />
        )}
      </Box>
    </ExtendedContainer>
  );
};
